import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Button,
  Divider,
  FormGroup,
} from "@material-ui/core";

import HeaderClientes from "components/_refactor/headers/clients.js";
import ClearButton from "components/_refactor/button/clear";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import PeriodField from "components/_refactor/fields/period-field";
import componentStyles from "assets/theme/views/admin/dashboard";
import componentStylesCardDeck from "assets/theme/components/cards/card-deck";

import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import LoadingData from "components/Loading/LoadingData";
import { VisitsIndicatorSummary } from "components/Reports/VisitsIndicatorSummary";
import Api from "lib/api/httpRequestHelper";
import useLogs from "hooks/logs";
import { IsMobile, IsMobile900 } from "utils/is-mobile";

const useStyles = makeStyles(componentStyles);
const useStylesCardDeck = makeStyles(componentStylesCardDeck);

const options = [
  { label: "Ano", value: "ano" },
  { label: "Dia da Semana", value: "dia semana" },
  { label: "Mês", value: "mensal" },
];

const dataHoje = new Date().toISOString().slice(0, 10);
const brands = JSON.parse(localStorage.getItem("usuarioMarcas")) || [];

export function DashboardAcompanhamentoVisitas() {
  const snackbar = useSnackbar();
  const classes = { ...useStyles(), ...useStylesCardDeck() };
  const { setLocalStorageActions, setLocalStorageApiProblem } = useLogs();

  const [brandDefaultValue, setBrandDefaultValue] = useState(
    brands.length === 1 ? brands[0] : brands[0]
  );
  const [selectedStore, setSelectedStore] = useState(null);
  const [searchingStore, setSearchingStore] = useState(false);
  const [storeList, setStoreList] = useState([]);
  const [hasNoBrand, setHasNoBrand] = useState(false);
  const [hasNoStore, setHasNoStore] = useState(false);
  const [grouper, setGrouper] = useState(options[0]);

  const [searching, setSearching] = useState(false);
  const [periodo, setPeriodo] = useState(30);
  const [dataInicial, setDataInicial] = useState(dataHoje);
  const [dataFinal, setDataFinal] = useState();
  const [clearFilters, setClearFilters] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [visitsIndicator, setVisitsIndicator] = useState([]);

  const isMobile900 = IsMobile900();
  const isMobile = IsMobile();

  const handleGetStoreList = async () => {
    setSearchingStore(true);

    await Api.get(
      "store",
      "commercialstructure",
      `?idMarca=${brandDefaultValue?.IdMarca}`,
      true
    )
      .then(({ Success, Result }) => {
        if (Success) {
          setStoreList(Result);
        }
      })
      .catch((error) => {
        setLocalStorageApiProblem({
          idMenuAccess: "162",
          screen: "Dashboard Acompanhamento de Visitas",
          problem: `Erro na chamada do endpoint store - ${error}`,
        });
        snackbar.showMessage(error, {
          severity: "error",
        });
      })
      .finally(() => setSearchingStore(false));
  };

  const submit = async () => {
    setCancelLoading(false);
    setSearching(true);
    setLocalStorageActions({
      nomeTela: "Dashboard Acompanhamento de Visitas",
      idMenu: "162",
      acao: "Acessou a tela Dashboard Acompanhamento de Visitas",
    });

    await Api.get(
      "sell-out-indicator-evolution",
      "selloutreport",
      `?idPessoaLoja=${selectedStore?.Id}` +
        `&dimensao=${grouper.value}` +
        +"&dtIni=" +
        dataInicial +
        "&dtFim=" +
        dataFinal,
      true
    )
      .then((resp) => {
        setVisitsIndicator(resp?.Result?.DashboardVisitasList);
      })
      .catch((error) => {
        setLocalStorageApiProblem({
          idMenuAccess: "162",
          screen: "Dashboard Acompanhamento de Visitas",
          problem: `Erro na chamada do endpoint sell-out-indicator-evolution - ${error}`,
        });
        snackbar.showMessage(
          "Não foram localizados registros. Tente novamente.",
          {
            severity: "error",
          }
        );
        console.log(error);
      });
    setSearching(false);
  };

  const handleClearFilters = () => {
    setClearFilters(true);
    setSearching(true);
    setPeriodo(30);
    setDataFinal(undefined);
    setDataInicial(dataHoje);
    setBrandDefaultValue(null);
    setSelectedStore(null);
    setGrouper(options[0]);
    setStoreList([]);
    setSearching(false);
    setTimeout(() => {
      setClearFilters(false);
    }, 1000);
  };

  const handleStopSearching = () => {
    setCancelLoading(true);
    setSearching(false);
    setVisitsIndicator([]);
  };

  const handleVerifyRequiredInputs = () => {
    if (brandDefaultValue && selectedStore) {
      return submit();
    } else {
      if (!brandDefaultValue) {
        setHasNoBrand(true);
      }

      if (!selectedStore) {
        setHasNoStore(true);
      }
    }
  };

  useEffect(() => {
    if (brandDefaultValue !== null) {
      handleGetStoreList();
    }
  }, [brandDefaultValue]);

  useEffect(() => {
    if (brandDefaultValue) {
      setHasNoBrand(false);
    }
    if (selectedStore) {
      setHasNoStore(false);
    }
  }, [brandDefaultValue, selectedStore]);

  return (
    <>
      <HeaderClientes
        section="Dashboard Acompanhamento de Visitas"
        subsection="Dashboard"
      />
      <Container style={{ marginTop: "-4.5rem" }} maxWidth={false}>
        <Grid container>
          <Grid item xs={12}>
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                className={classes.cardHeader}
                title="Filtros"
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <Grid container alignItems="center" spacing={2}>
                  <Grid item xs={12} sm={6} md={3}>
                    <FormGroup>
                      <AutoCompleteField
                        options={brands}
                        onChange={setBrandDefaultValue}
                        label="Marca"
                        optionIdKey="IdMarca"
                        disabled={searching || searchingStore}
                        loading={clearFilters}
                        value={brandDefaultValue}
                        required
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormGroup>
                      <AutoCompleteField
                        label="Loja *"
                        style={hasNoStore ? { border: "1px solid red" } : {}}
                        onChange={(newValue) => {
                          if (newValue !== "all") {
                            setSelectedStore(newValue);
                          } else {
                            setSelectedStore(null);
                          }
                        }}
                        value={selectedStore}
                        options={storeList}
                        disabled={searchingStore || searching}
                        optionLabelKey="Nome"
                        optionIdKey="Id"
                        customTooltipText={(option) =>
                          typeof option === "object" ? `${option.Apelido}` : ""
                        }
                        loading={clearFilters}
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} hidden={isMobile}>
                    <Divider />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <AutoCompleteField
                      label="Agrupador"
                      options={options}
                      optionLabelKey="label"
                      optionIdKey="value"
                      value={grouper}
                      onChange={setGrouper}
                      disabled={searching}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={9}>
                    <PeriodField
                      label="Período"
                      value={periodo}
                      onChange={setPeriodo}
                      disabled={searching || searchingStore}
                      initialDate={dataInicial}
                      finalDate={dataFinal}
                      setInitialDate={setDataInicial}
                      setFinalDate={setDataFinal}
                      padding
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Button
                      color="default"
                      variant="contained"
                      style={
                        isMobile || isMobile900
                          ? {
                              width: "100%",
                              marginBottom: "0.75rem",
                              marginTop: "0.75rem",
                            }
                          : { marginBottom: "0rem" }
                      }
                      onClick={handleVerifyRequiredInputs}
                      disabled={searching || searchingStore}
                    >
                      {searching ? "Pesquisando..." : "Pesquisar"}
                    </Button>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <ClearButton
                      disable={searching || searchingStore}
                      onClick={() => handleClearFilters()}
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <LoadingData
              searching={searching}
              onClick={() => handleStopSearching()}
              classes={classes.root}
              label="Buscando dados..."
            />
          </Grid>
          {visitsIndicator?.length !== 0 && !cancelLoading && !searching && (
            <Grid item xs={12}>
              <VisitsIndicatorSummary data={visitsIndicator} />
            </Grid>
          )}
        </Grid>
      </Container>
    </>
  );
}
